import { Project } from "@/api/project";
import { ProjectForm } from "./ProjectForm";
import { v4 as uuid } from "uuid";

export function CreateProject() {
  const defaultValues: Project = {
    id: uuid(),
    name: "",
    creationDate: new Date(),
  };

  return <ProjectForm data={defaultValues} />;
}
